import React from "react";
// import { Link } from "react-router-dom";
import {useTranslation} from 'react-i18next'
import "./Projects.scss";
// import { use } from "i18next";

function Projects() {
  const {t} = useTranslation();
  const map = [
    {
      id: 1,
      title1:t("homeProjects.title1"),
      title2: t("homeProjects.subTitle1"),
      url: "https://ieltsonlinetests.com/",
    },
    {
      id: 2,
      title1:t("homeProjects.title2"),
      title2: t("homeProjects.subTitle2"),
      url: "https://survival-russian.ru/uroki-russkogo-yazyka-dlya-inostrantsev/russkaia-grammatika/",
    },
    {
      id: 3,
      title1:t("homeProjects.title3"),
      title2: t("homeProjects.subTitle3"),
      url: "https://uz.khanacademy.org/science/chemistry",
    },
    {
      id: 4,
      title1:t("homeProjects.title4"),
      title2: t("homeProjects.subTitle4"),
      url: "https://uz.khanacademy.org/science/biology",
    },
    {
      id: 5,
      title1: t("homeProjects.title5"),
      title2: t("homeProjects.subTitle5"),
      url: "https://www.youtube.com/@SaidbekArislonov",
    },
    {
      id: 6,
      title1: t("homeProjects.title6"),
      title2: t("homeProjects.subTitle7"),
      url: "https://www.youtube.com/@virtualdars",
    },
    {
      id: 7,
      title1: t("homeProjects.title7"),
      title2: t("homeProjects.subTitle8"),
      url: "https://uz.khanacademy.org/science/physics/one-dimensional-motion/introduction-to-physics-tutorial/a/what-is-physics",
    },
    {
      id: 8,
      title1: t("homeProjects.title8"),
      title2: t("homeProjects.subTitle9"),
      url: "https://www.youtube.com/@kadirovgroup",
    },
  ];
  const map2 = map.map((a) => (
    <div className="each_part" key={a.id}>
      <a href={a.href}>
        <div className="in_wrapper">
          <div className="main_text">
            <h3>{a.title1}</h3>
          </div>
          <div className="hiidden_text">
            <p>
             {a.title2}
            </p>
            <a href={a.url}>{t("homeProjects.seeProject")}</a>
          </div>
        </div>
      </a>
    </div>
  ));
  return (
    <div className="projects" id="projects">
      <div className="wrapper">
      {map2}
      </div>  
    </div>
  );
}

export default Projects;
